﻿import React, { useState, useEffect } from 'react';
import { ProductListItem } from '../../models/product-list-item';
import { CrudFunctions } from '../../utilities/crud-functions';
import { RenderingFunctions } from '../../utilities/rendering-functions';

import DataGrid, {
    Column,
    Selection,
    Paging,
    Button as ColumnButton,
} from 'devextreme-react/data-grid';

export default function ProductFamilyComponent(props: any) {
    const [products, setProducts] =
        useState<ProductListItem[]>();

    useEffect(() => {
        getProductStates();
    }, [props]);

    return (
        <div style={{ marginLeft: "2rem", border : "1px solid #aaaadd"} }>
            <DataGrid width="100%"
                dataSource={products ? products : []}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnResizingMode='widget'
                keyExpr="productId"
                rowAlternationEnabled={true}
                showRowLines={true}
                showBorders={true}>

                <Paging enabled={false} />
                <Selection mode='single' />

                <Column type="buttons" width='3rem' >
                    <ColumnButton icon="edit" />
                </Column>

                <Column dataField='partNumber' dataType='string' width='15rem' />
                <Column dataField='productStateName' cellRender={productStateRender} dataType='string' width='10rem' />
                <Column />

            </DataGrid>
        </div>
    );

    async function getProductStates() {
        if (props && props.data && props.data.data && props.data.data.productId) {

            await CrudFunctions.getData(`products/productstates/${props.data.data.productId}`)
                .then(data => {
                    setProducts(data);
                })
        }
    }

    function productStateRender(e: any) {
        let product = e.data as ProductListItem;

        let cssClass = `pw-bold ${RenderingFunctions.returnProductStateColor(product.productState)}`;

        if (product.productId === props.data.data.productId)
            return <div className={cssClass}>{product.productStateName}</div>;
        else
            return <div>{product.productStateName}</div>;
    }

}

